/* AA PDP — habillage « maquette » des descriptions existantes (test_benjo).
   - masque le module versions quand le sélecteur le remplace
   - blocs à fond sombre : contraste garanti (classe aa-dark)
   - retire les émojis en tête des titres
   - numérote les étapes 01, 02…
   - génère une bande de chiffres clés depuis le tableau de caractéristiques */
(function () {
  'use strict';
  var EMOJI = /^[\s ]*(?:[☀-➿️‍]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDC00-\uDFFF])+[\s ]*/;

  function stripEmoji(el) {
    var n = el.firstChild;
    while (n && n.nodeType !== 3) n = n.firstChild;
    if (n && EMOJI.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(EMOJI, '');
  }

  function run() {
    var body = document.querySelector('.aa-pc .aa-body') || document.querySelector('.aa-pc .rte > .aa') || document.querySelector('.aa-pc .rte');
    if (!body) return;

    // Le module versions/coloris de la description n'est masqué que s'il fait doublon
    // avec les cartes du sélecteur (packs / versions, mêmes noms) : les pastilles de couleur
    // restent toujours affichées, même si le sélecteur montre des vignettes photo.
    var norm = function (s) {
      return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    };
    var shown = [];
    document.querySelectorAll('.aa-opt-cards input').forEach(function (i) { shown.push(norm(i.value)); });
    var dup = function (grid) {
      var names = Array.prototype.map.call(
        grid.querySelectorAll('.aa-var-n, .cc-name, .vc-name, .v-name'),
        function (n) { return norm(n.textContent); }
      ).filter(Boolean);
      if (!names.length || !shown.length) return false;
      var hit = names.filter(function (n) {
        return shown.some(function (v) { return v && (v === n || v.indexOf(n) > -1 || n.indexOf(v) > -1); });
      }).length;
      return hit / names.length >= 0.6;
    };
    if (shown.length) {
      Array.prototype.filter.call(body.querySelectorAll('.aa-versions-grid, .aa-var-grid, .aa-vars'), dup).forEach(function (grid) {
        grid.classList.add('aa-hide');
        var prev = grid.previousElementSibling;
        if (prev && /^H[23]$/.test(prev.tagName)) {
          prev.classList.add('aa-hide');
          if (prev.id) {
            var link = document.querySelector('.aa-toc a[data-target="' + prev.id + '"]');
            if (link) link.remove();
          }
        }
      });
    }

    body.querySelectorAll('div, section, aside').forEach(function (el) {
      var cs = getComputedStyle(el);
      var dark = false;
      var m = cs.backgroundColor.match(/[\d.]+/g);
      if (m && m.length >= 3 && (m.length < 4 || +m[3] > 0.5) && (+m[0] * 0.299 + +m[1] * 0.587 + +m[2] * 0.114) < 90) dark = true;
      var g = cs.backgroundImage.match(/rgb\(([\d.]+),\s*([\d.]+),\s*([\d.]+)/);
      if (!dark && /gradient/.test(cs.backgroundImage) && g && (+g[1] * 0.299 + +g[2] * 0.587 + +g[3] * 0.114) < 90) dark = true;
      if (dark) el.classList.add('aa-dark');
    });

    body.querySelectorAll('h2, h3, .lc-title').forEach(stripEmoji);
    document.querySelectorAll('.aa-toc a').forEach(stripEmoji);

    var SHORT = [
      [/version/i, 'Versions'], [/c[eè]dre|bois|mat[ée]ri/i, 'Matériau'], [/pr[ée]parer|seasoning|utilis/i, 'Préparation'],
      [/marque|format|compatib/i, 'Compatibilité'], [/sp[ée]cif|caract[ée]ristique/i, 'Caractéristiques'],
      [/cadeau/i, 'Idée cadeau'], [/question|faq/i, 'FAQ'], [/entretien/i, 'Entretien'], [/comparatif|compar/i, 'Comparatif'],
      [/principe|fonctionne/i, 'Principe'], [/adore|atout|avantage|points? fort/i, 'Points forts'], [/taille/i, 'Tailles']
    ];
    var tocLinks = Array.prototype.slice.call(document.querySelectorAll('.aa-toc a'));
    /* BBL début modif — 25/10/2026 : libellés courts du sommaire (en français) appliqués seulement sur le site en français ; ailleurs, titre de la section raccourci */
    var isFr = /^fr/i.test(document.documentElement.lang || 'fr');
    tocLinks.forEach(function (a) {
      var t = a.textContent;
      if (isFr) for (var i = 0; i < SHORT.length; i++) { if (SHORT[i][0].test(t)) { a.textContent = SHORT[i][1]; return; } }
      /* BBL fin modif */
      var full = (document.getElementById(a.dataset.target) || a).textContent.replace(/\s+/g, ' ').trim();
      a.textContent = full.length <= 22 ? full : full.split(' ').slice(0, 3).join(' ').replace(/[\s,;:—–-]+$/, '');
    });
    tocLinks.slice(6).forEach(function (a) { a.remove(); });

    body.querySelectorAll('.aa-step-num, .aa-step-n').forEach(function (n) {
      var t = n.textContent.trim();
      if (/^\d$/.test(t)) n.textContent = '0' + t;
    });

    if (!body.querySelector('.aa-figs')) {
      // BBL début modif — bande de chiffres clés (v2, 20/10/2026) : fourchettes et listes (20 à 35, 2, 4 ou 6),
      // milliers (1 240 g), dimensions avec unités (18,5 cm x 21 cm), lignes propres à une version ignorées,
      // légende = mot-clé + unité, une seule ligne par type de chiffre
      var rows = [];
      body.querySelectorAll('.aa-specs tr, .aa-sp tr').forEach(function (tr) {
        var td = tr.querySelectorAll('td, th');
        if (td.length >= 2) rows.push([td[0].textContent.replace(/\s+/g, ' ').trim(), td[1].textContent.replace(/\s+/g, ' ').trim()]);
      });
      /* BBL début modif — 25/10/2026 : libellés du tableau reconnus en français, anglais, allemand et néerlandais ; catégories par table */
      var KW = /(capaciteit(?:en)?|capacit[ée]s?|capacity|capacities|kapazit[äa]t(?:en)?|contenance|fassungsverm[öo]gen|inhoud|volumen?|dimensions?|abmessung(?:en)?|afmeting(?:en)?|poids|weight|gewicht|hauteur|height|h[öo]he|hoogte|diam[eè]tre|diameter|durchmesser|longueur|length|l[äa]nge|lengte)/i;
      var CATS = [
        [/capacit|kapazit|contenance|fassungsverm|inhoud|volum/i, 'cap'],
        [/dimension|abmessung|afmeting/i, 'dim'],
        [/poids|weight|gewicht/i, 'wei'],
        [/hauteur|height|h[öo]he|hoogte/i, 'hei'],
        [/diam|durchmesser/i, 'dia'],
        [/longueur|length|l[äa]nge|lengte/i, 'len']
      ];
      var catOf = function (s) { for (var i = 0; i < CATS.length; i++) { if (CATS[i][0].test(s)) return CATS[i][1]; } return String(s).toLowerCase().slice(0, 4); };
      /* BBL fin modif */
      var NUM = '\\d+(?:[.,]\\d+)?';
      var RE_DIM = new RegExp('^(' + NUM + ')\\s*(?:cm|mm)?\\s*[×x]\\s*(' + NUM + ')(?:\\s*(?:cm|mm)?\\s*[×x]\\s*(' + NUM + '))?');
      var RE_LIST = new RegExp('^' + NUM + '(?:\\s*(?:à|-|–|ou|·|/|et|to|or|and|bis|oder|und|tot|of|en)\\s*' + NUM + '|,\\s+' + NUM + ')+'); // BBL modif 25/10/2026 : liaisons en/de/nl
      var RE_ONE = new RegExp('^' + NUM);
      var f = function (s) { return parseFloat(s.replace(',', '.')); };
      var figs = [], seen = {};
      rows.forEach(function (r) {
        if (figs.length >= 4) return;
        var label = r[0], value = r[1].replace(/(\d) (\d{3})(?!\d)/g, '$1$2');
        var k = label.match(KW); if (!k) return;
        if (/[—–-]/.test(label.slice(0, k.index))) return;            // « 4 slots — dimensions » : ligne propre à une version
        var w = k[1].toLowerCase();
        var cat = catOf(w); // BBL modif 25/10/2026 : catégorie par table (4 langues)
        if (seen[cat]) return;
        var p = value.search(/\d/); if (p < 0) return;
        if (value.charAt(p - 1) === '(') return;                        // « Duo (2), Squad (4)… »
        var rest = value.slice(p), m, num;
        if (cat === 'dim') {                                            // dimensions : on cherche le motif L × l (× h) dans toute la valeur
          var d = value.match(new RegExp(RE_DIM.source.slice(1)));
          if (!d) return;
          rest = value.slice(d.index); m = d; num = [d[1], d[2], d[3]].filter(Boolean).join(' × ');
        } else if ((m = rest.match(RE_DIM))) num = [m[1], m[2], m[3]].filter(Boolean).join(' × ');
        else if ((m = rest.match(RE_LIST))) {
          var ns = m[0].match(new RegExp(NUM, 'g')).sort(function (a, b) { return f(a) - f(b); });
          num = ns[0] === ns[ns.length - 1] ? ns[0] : ns[0] + '–' + ns[ns.length - 1];
        } else { m = rest.match(RE_ONE); num = m[0]; }
        var unit = rest.slice(m[0].length).trim().split(/[\s—–(,·]/)[0].replace(/[^A-Za-zÀ-ÿ%"”]/g, '');
        if (!unit) { var before = value.slice(0, p).trim().split(/\s+/).pop() || ''; if (/^[A-Za-zÀ-ÿ]{2,}$/.test(before)) unit = before.toLowerCase(); }
        if (unit && (unit.toLowerCase().slice(0, 4) === w.slice(0, 4) || (unit.length > 3 && catOf(unit) === cat))) return;   // « 2 diamètres différents » (BBL modif 25/10/2026 : aussi « 2 diameters »)
        seen[cat] = 1;
        var word = k[1].charAt(0).toUpperCase() + k[1].slice(1).toLowerCase();
        var len = num.replace(/\s/g, '').length;
        figs.push({ n: num, c: word + (unit ? ' (' + unit + ')' : ''), size: len > 14 ? 'xlong' : len > 6 ? 'long' : '' });
      });
      // BBL fin modif
      if (figs.length >= 2) {
        var band = document.createElement('div');
        band.className = 'aa-figs';
        figs.forEach(function (f) {
          var d = document.createElement('div');
          var n = document.createElement('div'); n.className = 'aa-fig__n' + (f.size ? ' aa-fig__n--' + f.size : ''); n.textContent = f.n; // BBL modif : classes --long / --xlong
          var c = document.createElement('div'); c.className = 'aa-fig__c'; c.textContent = f.c;
          d.appendChild(n); d.appendChild(c); band.appendChild(d);
        });
        var anchor = body.querySelector('.aa-benefits, .aa-ben') || body.querySelector('.aa-intro, p');
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(band, anchor.nextSibling);
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();